import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FieldStates } from 'sos-common/js/commonTypes/formField.types';
import { FileExtendedDetails } from 'sos-common/js/commonTypes/fileupload.types';
import { FormFieldFile } from 'sos-common/js/commonTypes/formField.types';
import { ValidationResult } from 'sos-common/js/commonTypes/validation.types';
import { filesMap } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { ClientErrorsState } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { TextInput, Tooltip } from '../../..';
import { StepChildProps } from 'sos-common/js/components/WizardStepper/WizardStepper.types';

import {
  addFileActionFunc,
  addFilesAction,
  removeFileActionFunc,
  removeFilesAction,
  setFormValue,
  clearErrorDispatcher,
  clearError,
} from 'sos-eservice-common/js/Redux/Actions';

import { getErrorMessageByFieldName } from 'sos-common/js/utils/helpers';
import { makeTranslator } from 'sos-common/js/utils/translations';
import { translateFunc } from 'sos-common/js/utils/translations';
import { OmbudOrderModel } from '../models/OmbudOrderModel';
import { OmbudFormStore } from '../models/OmbudStore';
import { OmbudFormFiles } from '../components/OmbudFormFiles';

export interface Step2Props extends StepChildProps {
  Translate?: translateFunc;
  files: filesMap;
  validationResults: ValidationResult[];
  orderId: string;
  postFile: addFileActionFunc;
  deleteFile: removeFileActionFunc;
  setFormValue?: typeof setFormValue;
  formModel: OmbudOrderModel;
  clearError: clearError;
  firstName: string;
  lastName: string;
  errors: ClientErrorsState;
  powerOfAttorneyLink: string;
  readMoreAboutAttachmentsLink?: string;
}

export interface Step2State {}

class Step2 extends React.Component<Step2Props, Step2State> {
  constructor(props: any) {
    super(props);

    this.state = {};
  }

  public getTitle = () => 'Ombud';

  public removeFile = (file: FileExtendedDetails, fieldName: string, field: FormFieldFile) => {
    this.props.clearError(field);
    this.props.deleteFile(file, fieldName);
  };

  public onChangeField = (field: FieldStates) => {
    this.props.setFormValue(field);
  };

  public componentDidMount() {
    this.props.reportToWizard({
      stepLabel: this.getTitle(),
    });
  }

  public render() {
    const {
      Translate,
      formModel,
      files,
      orderId,
      firstName,
      lastName,
      validationResults,
      powerOfAttorneyLink,
      readMoreAboutAttachmentsLink,
      errors,
    } = this.props;
    const noOrderId = !orderId;

    return (
      <div id="step2" tabIndex={-1}>
        <div className="form-group">
          <h2 className="inlineblock">{Translate('|OmbudsansokanForm|tasknDelegete')}</h2>

          <div className="form-group-small row">
            <div className="col-md-6">
              <TextInput
                disabled={true}
                placeholder={'Förnamn'}
                value={_.get(formModel, 'Person.Fornamn')}
                errorMessage={getErrorMessageByFieldName(validationResults, 'Person.Fornamn')}
                fieldName="Person.Fornamn"
                onChange={this.onChangeField}
                label={Translate('|OmbudsansokanForm|firstname') + ' *'}
              />
            </div>
          </div>

          <div className="form-group-small row">
            <div className="col-md-6">
              <TextInput
                disabled={true}
                placeholder={'Efternamn'}
                value={_.get(formModel, 'Person.Efternamn')}
                errorMessage={getErrorMessageByFieldName(validationResults, 'Person.Efternamn')}
                fieldName="Person.Efternamn"
                onChange={this.onChangeField}
                label={Translate('|OmbudsansokanForm|lastname') + ' *'}
              />
            </div>
          </div>

          <div className="form-group-small row">
            <div className="col-md-6">
              <TextInput
                placeholder={'Tjänstetitel'}
                value={_.get(formModel, 'Befattning')}
                errorMessage={getErrorMessageByFieldName(validationResults, 'Befattning')}
                fieldName="Befattning"
                onChange={this.onChangeField}
                label={Translate('|OmbudsansokanForm|appointment') + ' *'}
                maxLength={160}
              />
            </div>
          </div>

          <div className="form-group-small row">
            <div className="col-md-6">
              <TextInput
                placeholder={'08-987 65 43'}
                value={_.get(formModel, 'Telefon')}
                errorMessage={getErrorMessageByFieldName(validationResults, 'Telefon')}
                fieldName="Telefon"
                onChange={this.onChangeField}
                label={Translate('|OmbudsansokanForm|telNr') + ' *'}
                maxLength={160}
              />
            </div>
          </div>

          <div className="form-group-small row">
            <div className="col-md-6">
              <TextInput
                placeholder={'Epost'}
                value={_.get(formModel, 'Epost')}
                errorMessage={getErrorMessageByFieldName(validationResults, 'Epost')}
                fieldName="Epost"
                onChange={this.onChangeField}
                label={Translate('|OmbudsansokanForm|epost') + ' *'}
                maxLength={160}
              />
            </div>
          </div>
        </div>

        <hr className="formdivider" />

        <div className="form-group">
          <h2 className="inlineblock">{Translate('|OmbudsansokanForm|orgtask')}</h2>

          <div className="form-group-small row">
            <div className="col-md-6">
              <TextInput
                placeholder={Translate('|OmbudsansokanForm|organizationName')}
                value={_.get(formModel, 'Organisation.Namn')}
                errorMessage={getErrorMessageByFieldName(validationResults, 'Organisation.Namn')}
                fieldName="Organisation.Namn"
                onChange={this.onChangeField}
                label={Translate('|OmbudsansokanForm|orgName')}
                maxLength={160}
              />
            </div>
          </div>

          <div className="form-group-small row">
            <div className="col-md-6">
              <TextInput
                placeholder={'123456-1234'}
                value={_.get(formModel, 'Organisation.Organisationsnummer')}
                errorMessage={getErrorMessageByFieldName(validationResults, 'Organisation.Organisationsnummer')}
                fieldName="Organisation.Organisationsnummer"
                onChange={this.onChangeField}
                label={Translate('|OmbudsansokanForm|orgNr') + ' *'}
                maxLength={160}
              />
            </div>
          </div>

          <div className="form-group-small row">
            <div className="col-md-6">
              <TextInput
                placeholder={'abc@mail.com'}
                value={_.get(formModel, 'Organisation.Epost')}
                errorMessage={getErrorMessageByFieldName(validationResults, 'Organisation.Epost')}
                fieldName="Organisation.Epost"
                onChange={this.onChangeField}
                label={Translate('|OmbudsansokanForm|orgEpost') + ' *'}
                maxLength={160}
              />
            </div>
          </div>

          <div className="form-group-small row">
            <div className="col-md-6">
              <TextInput
                placeholder={'organisation.se'}
                value={_.get(formModel, 'Organisation.Webbplats')}
                errorMessage={getErrorMessageByFieldName(validationResults, 'Organisation.Webbplats')}
                fieldName="Organisation.Webbplats"
                onChange={this.onChangeField}
                label={Translate('|OmbudsansokanForm|orgWebb')}
                maxLength={255}
              />
            </div>
          </div>
        </div>

        <hr className="formdivider" />

        <div className="form-group">
          <h2 className="inlineblock">{Translate('|OmbudsansokanForm|attachInsert')}</h2>

          <p>{Translate('|OmbudsansokanForm|bilagorInfo|intro')} </p>

          <h3>{Translate('|OmbudsansokanForm|bilagorInfo|heading1')}</h3>
          <ul>
            <li>{Translate('|OmbudsansokanForm|bilagorInfo|bullet1')}</li>
            <li>{Translate('|OmbudsansokanForm|bilagorInfo|bullet2')}</li>
            <li>{Translate('|OmbudsansokanForm|bilagorInfo|bullet3')}</li>
            <li>
              {Translate('|OmbudsansokanForm|bilagorInfo|bullet4')}
              <a className="external-link" href={powerOfAttorneyLink} target="_blank">
                {Translate('|OmbudsansokanForm|bilagorInfo|powerofattorneylinktext')}
              </a>
            </li>
          </ul>
          <h3>{Translate('|OmbudsansokanForm|bilagorInfo|heading2')}</h3>
          <ul>
            <li>{Translate('|OmbudsansokanForm|bilagorInfo|bullet5')}</li>
            <li>{Translate('|OmbudsansokanForm|bilagorInfo|bullet6')}</li>
            <li>
              {Translate('|OmbudsansokanForm|bilagorInfo|bullet7')}
              <a className="external-link" href={powerOfAttorneyLink} target="_blank">
                {Translate('|OmbudsansokanForm|bilagorInfo|powerofattorneylinktext')}
              </a>
            </li>
          </ul>
          <h3>{Translate('|OmbudsansokanForm|bilagorInfo|heading3')}</h3>
          <ul>
            <li>{Translate('|OmbudsansokanForm|bilagorInfo|bullet8')}</li>
            <li>
              {Translate('|OmbudsansokanForm|bilagorInfo|bullet9')}
              <a className="external-link" href={powerOfAttorneyLink} target="_blank">
                {Translate('|OmbudsansokanForm|bilagorInfo|powerofattorneylinktext')}
              </a>
            </li>
          </ul>

          {readMoreAboutAttachmentsLink && (
            <p>
              <a className="external-link" href={readMoreAboutAttachmentsLink} target="_blank">
                Läs mer om bilagor
              </a>
            </p>
          )}
        </div>

        <OmbudFormFiles
          Translate={Translate}
          errors={errors}
          clearError={this.props.clearError}
          postFile={this.props.postFile}
          files={files}
          deleteFile={this.props.deleteFile}
          validationResults={validationResults}
        />

        <hr className="formdivider formdivider--m-t-none formdivider--m-b-small" />
      </div>
    );
  }
}

const mapState2Props = (state: OmbudFormStore) => {
  const { errors, files, formModel, globals, validationState } = state;
  const { orderId, firstName, lastName, translations, powerOfAttorneyLink, readMoreAboutAttachmentsLink } = globals;
  return {
    errors: errors,
    files: files,
    formModel: formModel,
    orderId: orderId,
    firstName: firstName,
    lastName: lastName,
    stepValidationMap: validationState.stepValidationMap,
    Translate: makeTranslator(translations),
    validationResults: validationState.validationResults,
    powerOfAttorneyLink,
    readMoreAboutAttachmentsLink,
  } as Partial<Step2Props>;
};

const mapDispatch2Props = (dispatch) => {
  return {
    clearError: clearErrorDispatcher(dispatch),
    deleteFile: bindActionCreators(removeFilesAction, dispatch),
    postFile: bindActionCreators(addFilesAction, dispatch),
    setFormValue: bindActionCreators(setFormValue, dispatch),
  };
};

const StepTwo = connect(mapState2Props, mapDispatch2Props)(Step2);
export { StepTwo };
